export enum WhatDoYouDoEnum {
    NotEmployed = 'I’m not Employed',
    Retired = 'I’m Retired',
    Studying = 'I’m Studying',
    Employed = 'I’m Employed',
}
